export default class ProductConfig {
  constructor({ nameKey, hintText, usageOptions, sizeOptions, bottleIcon }) {
    this.nameKey = nameKey;
    this.hintText = hintText;
    this.usageOptions = usageOptions;
    this.sizeOptions = sizeOptions;
    this.bottleIcon = bottleIcon;
  }
}
